import React from 'react';
import { Routes, Route } from 'react-router-dom';
import App from './App';
import Industria from './pages/Industria';
import Comercio from './pages/Comercio';
import Revendedor from './pages/Revendedor';
import Licitante from './pages/Licitante';
import LojaIluminacao from './pages/LojaIluminacao';
import Empresa from './pages/Empresa';
import Condominio from './pages/Condominio';
import Construtora from './pages/Construtora';
import LojaMateriais from './pages/LojaMateriais';
import Decorador from './pages/Decorador';
import Arquiteto from './pages/Arquiteto';
import Engenheiro from './pages/Engenheiro';
import MestreObras from './pages/MestreObras';
import Igreja from './pages/Igreja';
import PostoCombustivel from './pages/PostoCombustivel';

const RootRouter = () => (
  <Routes>
    <Route path="/" element={<App />} />
    <Route path="/led-para-industria" element={<Industria />} />
    <Route path="/led-para-comercio" element={<Comercio />} />
    <Route path="/led-para-revendedor" element={<Revendedor />} />
    <Route path="/led-para-licitante" element={<Licitante />} />
    <Route path="/led-para-loja-de-iluminacao" element={<LojaIluminacao />} />
    <Route path="/led-para-empresa" element={<Empresa />} />
    <Route path="/led-para-condominio" element={<Condominio />} />
    <Route path="/led-para-construtora" element={<Construtora />} />
    <Route path="/led-para-loja-de-materiais-eletricos" element={<LojaMateriais />} />
    <Route path="/led-para-decorador-de-ambiente" element={<Decorador />} />
    <Route path="/led-para-arquiteto" element={<Arquiteto />} />
    <Route path="/led-para-engenheiro" element={<Engenheiro />} />
    <Route path="/led-para-mestre-de-obras" element={<MestreObras />} />
    <Route path="/led-para-igreja" element={<Igreja />} />
    <Route path="/led-para-posto-de-combustivel" element={<PostoCombustivel />} />
  </Routes>
);

export default RootRouter;